import { getRequest } from "./api";

/* 格式化后端返回的数据 */
export const initMenu = (router, store) => {
    /* 如果vuex的store中的state数组不为空直接返回 */
    if (store.state.routes.length > 0) {
        return;
    }
    /* 如果为空发送get请求 */
    getRequest("/tpa-api/menu/getMenu").then(data => {
        if (data.result) {
            let fmtRoutes = formatRoutes(data.result);
            router.addRoutes(fmtRoutes);
            store.commit('initRoutes', fmtRoutes);
        }
    })
}

export const formatRoutes = (routes) => {
    let fmRoutes = [];

    routes.forEach(router => {
        let {
            path,
            component,
            name,
            name_en,
            name_zh,
            meta,
            icon
        } = router;
       
        let fmRouter = {
            path: path,
            name: name,
            name_en: name_en,
            name_zh: name_zh,
            icon: icon,
            meta: meta,
            component(resolve) {  /* 将component中的字符串凭借成views目录下的component.vue页面,不然不能显示.vue页面， */
				if(component.startsWith("Home")){
					require(['../views/'+component+'.vue'],resolve); 
				} else {
					require(['../views/pages/'+component+'.vue'],resolve); 
				}
               
            }
        }
        // 放入到数组中去
        fmRoutes.push(fmRouter);
    })

    return fmRoutes;
}
